import { Routes, Route, Link} from "react-router-dom";
//
import './App.css';
import 'antd/dist/antd.css';
import Navbar from './components/Navbar'
import Footer from "./components/Footer";
import Pool from './pages/Pool';
import PoolsList from './pages/PoolsList';
import History from "./pages/History";
import TokenInfo from "./pages/Token";
import UserInfo from "./pages/User";
import Graph from "./pages/graph/Graph";


// import Test from "./components/test";
//1d71e3b060636f1ae9472961523852d0


function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<PoolsList />} />
        <Route path="/history" element={<History />} />
        <Route path="/pool/:slug" element={<Pool />} />
        <Route path="/token/:tokenAddress" element={<TokenInfo/>} />
        {/* <Route path="/user" element={<UserInfo/>} /> */}
        {/* <Route path="/graphs" element={<Graph/>} /> */}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
